import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translations from "./translations";
import extraTranslations from "./extraTranslations";
import testsModuleTranslations from "./testsModuleTranslations";
import messagesTranslations from "./messagesTranslations";
import studentHomeTranslations from "./studentHomeTranslations";
import homeworkUiTranslations from "./homeworkUiTranslations";
import teacherStudentsTranslations from "./teacherStudentsTranslations";

// Adds keys from `extra` that `base` lacks, without overwriting anything.
function fillMissing(base, extra) {
  if (!extra) return base;
  const out = { ...base };
  Object.entries(extra).forEach(([key, value]) => {
    const current = out[key];
    if (value && typeof value === "object" && !Array.isArray(value)) {
      if (current === undefined || (current && typeof current === "object")) {
        out[key] = fillMissing(current || {}, value);
      }
    } else if (current === undefined) {
      out[key] = value;
    }
  });
  return out;
}

// Replaces values in `base` with those from `overrides`.
function override(base, overrides) {
  if (!overrides) return base;
  const out = { ...base };
  Object.entries(overrides).forEach(([key, value]) => {
    const current = out[key];
    out[key] =
      value && typeof value === "object" && !Array.isArray(value)
        ? override(current && typeof current === "object" ? current : {}, value)
        : value;
  });
  return out;
}

const resources = Object.entries(translations).reduce((acc, [lang, value]) => {
  const filled = fillMissing(value, extraTranslations[lang]);
  acc[lang] = {
    translation: [
      testsModuleTranslations,
      messagesTranslations,
      studentHomeTranslations,
      homeworkUiTranslations,
      teacherStudentsTranslations,
    ].reduce((out, module) => override(out, module[lang]), filled),
  };
  return acc;
}, {});

const FALLBACK_LANG = "fr";
const SUPPORTED_LANGS = Object.keys(translations);

export function initI18n(initialLang) {
  const lng = initialLang || FALLBACK_LANG;

  i18n
    .use(initReactI18next)
    .init({
      resources,
      lng,
      // Prefer English as the fallback for LTR languages, so partially-translated
      // locales (fr/de/it/es) don't unexpectedly show Arabic strings.
      fallbackLng: {
        ar: ["ar", "en"],
        default: ["en", "ar"],
      },
      supportedLngs: SUPPORTED_LANGS,
      nonExplicitSupportedLngs: true,
      load: "languageOnly",
      interpolation: { escapeValue: false },
      returnNull: false,
      returnEmptyString: false,
    });

  return i18n;
}

export default i18n;
